import { LoggedInUser } from '../../../types/auth.types';
import EmployerLanding from '../containers/EmployerLanding';
import Page from '../layout/base.page';

export type EmployerLandingPageProps = {
    url: string
    user?: LoggedInUser
}

const EmployerLandingPage = (props: EmployerLandingPageProps): JSX.Element => (
    <Page
        user={props.user}
        showBreadCrumbs={false}
        url={props.url}
    >
        <EmployerLanding user={props.user} />
    </Page>
);

export default EmployerLandingPage;
